import AiGenerativeChaptersIcon from '@atlaskit/icon-lab/core/ai-generative-chapters';
import * as React from 'react';

export function SvgAutoChapters() {
  return <AiGenerativeChaptersIcon label="" testId="ads-refreshed-icon" />;
}
